// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export default function UploadFilesProgress(props) {

  const open = props.open || false;
  // const onCancel = props.onCancel;
  const fileCount = props.fileCount || 0;
  const overAllProgress = props.overAllProgress || 0;
  const curFilename = props.curFilename || "";
  const curFileNo = props.curFileNo || 0;



  // const handleCancelClick = () => {
  //   onCancel && onCancel();
  // }

  return (
    <Dialog
      open={open}
      // onClose={handleCloseClick}
      aria-describedby="upload-progress-dialog-description"
      sx={{ '& .MuiDialog-paper': { width: '80%' } }}
      maxWidth="md"
    >
      <DialogTitle id="upload-progress-dialog-title">
        {`Uploading Files (${curFileNo}/${fileCount})`}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress variant="determinate" value={overAllProgress} />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography variant="body2" color="text.secondary">{`${Math.round(
              overAllProgress,
            )}%`}</Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box >
            <CircularProgress color="secondary" />
          </Box>
          <Box sx={{ flexGrow: 1, ml: 1 }}>
            <Typography variant="body2" color="text.secondary">{`${curFilename}`}</Typography>

          </Box>




        </Box>
      </DialogContent>
      {/* <DialogActions>
        <Button onClick={handleCancelClick}>Cancel</Button>
      </DialogActions> */}
    </Dialog>

  );
}

UploadFilesProgress.propTypes = {
  open: PropTypes.bool,
  // onCancel: PropTypes.func,
  fileCount: PropTypes.number,
  overAllProgress: PropTypes.number,
  curFilename: PropTypes.string,
  curFileNo: PropTypes.number,
};
